import { render, staticRenderFns } from "./onlineMall.vue?vue&type=template&id=0a320806&scoped=true"
import script from "./onlineMall.vue?vue&type=script&lang=js"
export * from "./onlineMall.vue?vue&type=script&lang=js"
import style0 from "./onlineMall.vue?vue&type=style&index=0&id=0a320806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a320806",
  null
  
)

export default component.exports